import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { diemKyHieuApi } from "../../../api/category/diemKyHieuApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { IDmDiemKyHieu } from "../../../model/response/category/IDmDiemKyHieu";
import { eDiemKyHieuActionIds, IDiemKyHieuActionTypes } from "../../action-types/category/IDiemKyHieuActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";

const mainAction = rootActions.category.diemKyHieu;
export function* diemKyHieuSaga(): any {
    yield takeLatest(eDiemKyHieuActionIds.LOAD_START, loadWoker);
    yield takeEvery(eDiemKyHieuActionIds.SAVE_START, saveWorker);
    yield takeEvery(eDiemKyHieuActionIds.DELETE_START, deleteWorker);
}
function* loadWoker(): any {
    const res: IBaseResponse = yield call(diemKyHieuApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS( toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải điểm ký hiệu"));
    }
}
function* saveWorker(action: IDiemKyHieuActionTypes): any {
    let res: IBaseResponse;
    const payload = action.payload as IDmDiemKyHieu;
    if (payload.id > 0){
        res = yield call(diemKyHieuApi.Update, payload.id, payload);
    } else {
        res = yield call(diemKyHieuApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu điểm hiệu"));
    }
}

function* deleteWorker(action: IDiemKyHieuActionTypes): any {
    console.log("🚀 ~ deleteWorker ~ action:", action)
    const id = action.payload as number;
    const res: IBaseResponse = yield call(diemKyHieuApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS( toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa điểm ký hiệu"));
    }
}